module.exports = __webpack_public_path__ + "static/logo-white-30e54687dc60e1131b38754b41a99fe4.png";